import { listingCategoryLabel } from "../data/listingCategories";

const statusTabs = [
  { id: "active", label: "Aktive" },
  { id: "draft", label: "Kladder" },
  { id: "sold", label: "Solgte" },
  { id: "archived", label: "Arkiverede" },
];

function SalesPage({
  actionError,
  actionListingId,
  activeStatus,
  error,
  isLoading,
  listings,
  onCreateListing,
  onEditListing,
  onListingImage,
  onOpenListing,
  onMarkSold,
  onPublishListing,
  setActiveStatus,
}) {
  const visibleListings = listings.filter((listing) => listing.status === activeStatus);

  return (
    <section className="main-panel">
      <div className="page-heading sales-heading">
        <div>
          <span className="mini-label">Mine annoncer</span>
          <h1>Hold styr på dine salg</h1>
          <p>
            Se dine egne annoncer efter status, og folg arbejdet fra kladde til
            aktiv annonce og solgt vare.
          </p>
        </div>
        <button className="primary-action page-action" onClick={onCreateListing} type="button">
          Opret annonce
        </button>
      </div>

      <div className="sales-tabs">
        {statusTabs.map((tab) => (
          <button
            className={activeStatus === tab.id ? "active" : ""}
            key={tab.id}
            onClick={() => setActiveStatus(tab.id)}
            type="button"
          >
            {tab.label}
          </button>
        ))}
      </div>

      {isLoading && <div className="empty-results">Henter dine annoncer...</div>}

      {!isLoading && error && (
        <div className="empty-results">
          <strong>Kunne ikke hente annoncer</strong>
          <p>{error}</p>
        </div>
      )}

      {!isLoading && !error && actionError && (
        <p className="status-line error">{actionError}</p>
      )}

      {!isLoading && !error && visibleListings.length === 0 && (
        <div className="empty-results">
          <strong>Ingen annoncer her endnu</strong>
          <p>{emptyText(activeStatus)}</p>
        </div>
      )}

      {!isLoading && !error && visibleListings.length > 0 && (
        <div className="sales-list">
          {visibleListings.map((listing, index) => {
            const image = onListingImage?.(listing, index);

            return (
              <article className="sale-card" key={listing.id}>
                {image ? (
                  <img
                    src={image}
                    alt=""
                  />
                ) : (
                  <div className="sale-image-placeholder">Intet billede</div>
                )}
                <div>
                  <span className={`status-pill ${listing.status === "sold" ? "sold" : ""}`}>
                    {statusLabel(listing.status)}
                  </span>
                  <h2>{listing.title}</h2>
                  <strong>{formatPrice(listing)}</strong>
                  <div className="sale-metrics">
                    <span>{listingCategoryLabel(listing.category)}</span>
                    <span>{listing.location || "Ingen lokation"}</span>
                    <span>{listing.condition || "Stand ikke angivet"}</span>
                  </div>
                  <div className="sale-actions">
                    <button onClick={() => onOpenListing(listing, index)} type="button">
                      Detaljer
                    </button>
                    {(listing.status === "draft" || listing.status === "active") && (
                      <button onClick={() => onEditListing(listing)} type="button">
                        Rediger
                      </button>
                    )}
                    {listing.status === "draft" && (
                      <button
                        disabled={actionListingId === listing.id}
                        onClick={() => onPublishListing(listing)}
                        type="button"
                      >
                        Publicer
                      </button>
                    )}
                    {listing.status === "active" && (
                      <button
                        disabled={actionListingId === listing.id}
                        onClick={() => onMarkSold(listing)}
                        type="button"
                      >
                        Marker solgt
                      </button>
                    )}
                  </div>
                </div>
                <div className={`quality-badge ${qualityClass(listing.ai_score)}`}>
                  <span>Rating</span>
                  <strong>{listing.ai_score ?? "-"}</strong>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </section>
  );
}

function emptyText(status) {
  if (status === "draft") {
    return "Dine kommende annoncer vises her, når du opretter en kladde.";
  }
  if (status === "sold") {
    return "Solgte varer samles her, når du markerer en annonce som solgt.";
  }
  if (status === "archived") {
    return "Arkiverede annoncer holdes skjult fra almindelige visninger.";
  }
  return "Publicer en kladde for at gore din forste annonce aktiv.";
}

function formatPrice(listing) {
  return `${listing.price_amount} ${listing.price_currency}`;
}

function statusLabel(status) {
  const labels = {
    active: "Aktiv",
    archived: "Arkiveret",
    draft: "Kladde",
    sold: "Solgt",
  };

  return labels[status] || status;
}

function qualityClass(score) {
  if (score === null || score === undefined) {
    return "unrated";
  }
  if (score >= 75) {
    return "strong";
  }
  if (score >= 50) {
    return "fair";
  }
  return "weak";
}

export default SalesPage;
